module.exports = __webpack_public_path__ + "static/media/1-iveco.ae36f6bc.jpg";